import { useCallback } from "react";
import { getCurrentPlant } from "../../../util/ApiOptionsHelper";
import { getColumnsWithGroup } from "../../../api/Windows";
import { logCustomMessage } from "../../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useWorkOrderStore } from "../../../store/wo-order";

export default function useGetTimeEntryMetaData() {
  const setTimeEntryMetaData = useWorkOrderStore(
    (state: any) => state.setTimeEntryMetaData
  );

  const getTimeEntryMetaData = useCallback(async () => {
    const data = {
      IncludeValidValues: "true",
      IncludeValidValuesExceptions: ["Equipment"],
      ValidValueFilters: [],
      WindowName: "mob_wo_labor",
      ContextPKey: {
        Plant: await getCurrentPlant(),
        WoBase: "",
        WoTask: "  ",
        WoSubtask: "  ",
      },
    };
    const response = await getColumnsWithGroup(data);
    logCustomMessage(
      "Get all employee IDs",
      SeverityLevel.Information,
      "Windows/GetColumnsWithGroup",
      data,
      response
    );
    if (response.status === 200 && !response.isError &&
      response.data?.fields &&
      Object.keys(response.data.fields).length > 0) {
      setTimeEntryMetaData(response.data);
    }
    return response;
  }, [setTimeEntryMetaData]);

  return { getTimeEntryMetaData };
}
